export enum MultimediaDetailRenderMode {
  Modal,
  Page
}
